import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import { CATEGORIES, getTemplate } from "../lib/templates";

export function BounceState({ message, onPickCategory }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.resolvedLanguage || "en";

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="flex flex-col items-center text-center gap-6"
      data-testid="bounce-state"
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 240, damping: 18 }}
        className="relative"
      >
        <span className="absolute inset-0 rounded-full bg-[#D4AF37]/10 blur-xl animate-pulse" aria-hidden />
        <span className="relative inline-flex h-16 w-16 items-center justify-center rounded-full border border-[#D4AF37]/40 bg-[#D4AF37]/10">
          <AlertTriangle className="h-8 w-8 text-[#D4AF37]" />
        </span>
      </motion.div>

      <div>
        <div className="text-xs uppercase tracking-[0.18em] text-[#D4AF37]/80">
          {t("bounce.title")}
        </div>
        <p
          className="mt-3 max-w-md text-base sm:text-lg text-white/85 leading-relaxed"
          data-testid="bounce-message"
        >
          {message}
        </p>
      </div>

      <div className="flex flex-wrap justify-center gap-2" data-testid="bounce-categories">
        {CATEGORIES.map((c) => (
          <button
            key={c}
            type="button"
            onClick={() => onPickCategory?.(c, getTemplate(lang, c))}
            data-testid={`bounce-cat-${c}`}
            className="rounded-full border border-white/15 bg-white/[0.04] px-4 py-2 text-sm text-white/80 hover:border-[#D4AF37]/40 hover:text-white hover:bg-white/[0.08] transition-colors"
          >
            {t(`bounce.cat.${c}`)}
          </button>
        ))}
      </div>
    </motion.div>
  );
}

export default BounceState;
